(ns core.util.string
  (:require #?(:cljs [goog.string :as gstr])
            #?(:cljs [goog.string.format])
            [clojure.string :as str]
            [potpuri.core :as p]))

(defn blank->nil
  "If `s` is a [[clojure.string/blank?]] string return `nil`. Else return `s`.
  (Useful because [[clojure.string/blank?]] only accepts a string ([[CharSequence]] on JVM) or `nil`.)"
  [s]
  (when-not (and (string? s) (str/blank? s))
    s))

(defn leading-zeroes
  "(leading-zeroes 123 7) => \"0000123\""
  [value digits]
  #?(:clj  (format (str "%0" digits "d") value)
     :cljs (gstr/format (str "%0" digits "d") value)))

(defn recursive-trim [v]
  (cond
    (map? v) (p/map-vals recursive-trim v)
    (coll? v) (map recursive-trim v)
    (string? v) (str/trim v)
    :else v))

(defn common-prefix
  "Given multiple strings, return whatever common prefix they have, or nil if none. Case sensitive.

  Cloud permit
  Cloud compute
   => 'Cloud '"
  [strs]
  (some->> strs
           (apply map vector)
           (take-while #(apply = %))
           seq
           (map first)
           (apply str)))

(defn trim-to-length
  "If `text` is longer than `max-length`, return a substring from 0 to `max-length`."
  [text max-length]
  (some-> text (subs 0 (min (count text) max-length))))

(defn normalized-equals?
  "Returns true if both strings are equal after trimming and lowercasing."
  [s1 s2]
  (= (some-> s1 str/trim str/lower-case)
     (some-> s2 str/trim str/lower-case)))

(defn looks-like-json-object? [maybe-json]
  (and (string? maybe-json)
       (str/starts-with? maybe-json "{")
       (str/ends-with? maybe-json "}")))
